import { motion } from "framer-motion";
import { Starfield } from "@/components/Starfield";

export const Splash = () => {
  const lang = (localStorage.getItem("lang") || (navigator.language || "en")).toLowerCase().startsWith("zh") ? "zh" : "en";
  const name = lang === "zh" ? "魔法筆記本" : "Magic Notebook";
  const badge = lang === "zh" ? "世界心情地圖" : "World Mood Map";

  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.7 }}
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#050814]"
      data-testid="splash-screen"
    >
      <Starfield />
      <div className="relative z-10 flex flex-col items-center">
        <motion.div
          initial={{ scale: 0.7, opacity: 0, y: 10 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="relative"
        >
          <div
            className="absolute inset-0 rounded-3xl blur-2xl"
            style={{ background: "radial-gradient(circle, rgba(212,175,55,0.55), transparent 70%)" }}
          />
          <motion.img
            src="/icon.png"
            alt="魔法筆記本"
            className="relative h-32 w-32 rounded-3xl border border-[#D4AF37]/40 object-cover shadow-[0_0_60px_rgba(212,175,55,0.5)] sm:h-40 sm:w-40"
            animate={{ y: [0, -8, 0] }}
            transition={{ duration: 3.2, repeat: Infinity, ease: "easeInOut" }}
          />
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.8 }}
          className="mt-8 font-decorative text-4xl leading-tight tracking-tight gold-text sm:text-5xl"
        >
          {name}
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.9, duration: 0.8 }}
          className="mt-3 text-xs tracking-[0.4em] text-[#D4AF37]/70"
        >
          {badge.toUpperCase()}
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.1 }}
          className="mt-10 h-[2px] w-40 overflow-hidden rounded-full bg-white/10"
        >
          <motion.div
            className="h-full w-1/2 rounded-full"
            style={{ background: "linear-gradient(90deg, transparent, #D4AF37, transparent)" }}
            animate={{ x: ["-100%", "220%"] }}
            transition={{ duration: 1.3, repeat: Infinity, ease: "easeInOut" }}
          />
        </motion.div>
      </div>
    </motion.div>
  );
};
